import { Controller } from '@hotwired/stimulus';
import { Modal } from 'bootstrap';
import $ from "jquery";

/* stimulusFetch: 'lazy' */
export default class extends Controller {
    static targets = [
        'form',
    ];

    static values = {
        chatId: Number,
    };

    connect() {
        this.modal = new Modal(this.element, {
            backdrop: 'static',
            focus: false,
            show: false,
        });
    }

    show() {
        showPreloader();

        $.get(routes['app_messages_deletechat'].replace('__id__', this.chatIdValue), result => {
            const $form = $(result);
            this.element.replaceChild($form[0], this.formTarget);
            this.modal.show();
            hidePreloader();
        });
    }

    confirm() {
        showPreloader();

        this.formTarget.submit();
    }
}
